/**
 * Tipos compartilhados da biblioteca de UI.
 *
 * Nada aqui é estado de negócio: são apenas os rótulos que a interface precisa
 * conhecer para pintar cor e texto.
 */

/**
 * Espelha `STATUS_CONTRATO` de `packages/domain/src/contrato/estados.ts`
 * (RN-018 a RN-030).
 *
 * A web não importa o domínio — ver `docs/arquitetura.md`, "Quem pode importar
 * quem": o único contrato de tipos que a web consome é o client gerado do
 * OpenAPI. Enquanto ele não existe, este union é a cópia declarada, e a
 * INTEGRACAO.md registra a troca como pendência.
 */
export const STATUS_CONTRATO = [
  'ABERTO',
  'APROVACAO_ASSESSOR',
  'APROVACAO_FORNECEDOR',
  'EM_ASSINATURA',
  'FECHADO',
] as const;

export type StatusContrato = (typeof STATUS_CONTRATO)[number];

/** Rótulo em português de cada estado, para exibição. */
export const ROTULO_STATUS_CONTRATO: Readonly<Record<StatusContrato, string>> = {
  ABERTO: 'Aberto',
  APROVACAO_ASSESSOR: 'Aprovação do assessor',
  APROVACAO_FORNECEDOR: 'Aprovação do fornecedor',
  EM_ASSINATURA: 'Em assinatura',
  FECHADO: 'Fechado',
};

/**
 * Explicação curta de cada estado — o legado não dizia ao operador o que estava
 * travando o contrato, e a dúvida "por que não fecha?" virava chamado.
 */
export const DESCRICAO_STATUS_CONTRATO: Readonly<Record<StatusContrato, string>> = {
  ABERTO: 'Em edição. Ainda aceita alteração de fornecedor, deságio e meses.',
  APROVACAO_ASSESSOR: 'Aguardando a decisão do assessor responsável.',
  APROVACAO_FORNECEDOR: 'Aguardando a decisão do fornecedor do crédito.',
  EM_ASSINATURA: 'Contrato gerado e enviado para assinatura eletrônica.',
  FECHADO: 'Assinado por todas as partes. Cronograma de envios ativo.',
};

/**
 * Tom semântico usado por selos, estados e realces.
 *
 * `positivo` é o único que usa o verde — §8 reserva verde para economia.
 */
export type TomSemantico =
  'neutro' | 'informativo' | 'progresso' | 'atencao' | 'positivo' | 'critico';

/** Densidade de informação. A ferramenta é fiscal: `compacta` é o padrão de tabela. */
export type Densidade = 'compacta' | 'confortavel';
